import React from "react";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import Slider from "@mui/material/Slider";
import Button from "@mui/material/Button";

export default function ContestContainerN({
  price,
  entryFee,
  totalSpots,
  spotsLeft,
  numWinners,
  onJoin,
  isAlmostFull,
  onClick,
  children,
}) {

  const spotsFilled = totalSpots - spotsLeft;
  const spotsPercent =
    totalSpots > 0 ? Math.round((spotsFilled / totalSpots) * 100) : 0;

  return (
    <div
      onClick={onClick}
      style={{
        background: "#ffffff",
        borderRadius: "12px",
        padding: "12px",
        margin: "10px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
        position: "relative",
        cursor: "pointer",
        border: "1px solid #eee",
      }}
    >

      {/* Top Row */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "6px"
        }}
      >

        {/* Prize Pool */}
        <div>
          <div
            style={{
              fontSize: "11px",
              color: "#777",
              marginBottom: "2px"
            }}
          >
            Prize Pool
          </div>

          <div
            style={{
              fontSize: "20px",
              fontWeight: "700"
            }}
          >
            ₹{price}
          </div>
        </div>

        {/* Entry Fee Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onJoin && onJoin(e);
          }}
          style={{
            background: "#2e7d32",
            color: "#fff",
            border: "none",
            padding: "6px 14px",
            borderRadius: "20px",
            fontWeight: "700",
            fontSize: "13px",
            cursor: "pointer"
          }}
        >
          ₹{entryFee}
        </button>

      </div>

      {/* Progress Bar */}
      <div
        style={{
          height: "6px",
          background: "#eeeeee",
          borderRadius: "10px",
          overflow: "hidden",
          marginBottom: "6px"
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${spotsPercent}%`,
            background: "#43a047",
            transition: "width 0.3s ease"
          }}
        />
      </div>

      {/* Spots Row */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "12px",
          marginBottom: "6px"
        }}
      >
        <span
          style={{
            color: spotsLeft <= 2 ? "#d32f2f" : "#444",
            fontWeight: "600"
          }}
        >
          {spotsLeft} Left
        </span>

        <span style={{ color: "#444" }}>
          {spotsFilled}/{totalSpots}
        </span>
      </div>

      {/* Bottom Info Row */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "12px",
          color: "#555"
        }}
      >
        <span style={{ display: "flex", alignItems: "center" }}>
          <PeopleAltOutlinedIcon style={{ fontSize: 16, marginRight: 4 }} />
          {totalSpots} Spots
        </span>

        <span style={{ display: "flex", alignItems: "center" }}>
          <EmojiEventsOutlinedIcon style={{ fontSize: 16, marginRight: 4 }} />
          {numWinners} Winner
        </span>
      </div>

      {/* Join Button */}
      <Button
        variant="contained"
        onClick={(e) => {
          e.stopPropagation();
          onJoin && onJoin(e);
        }}
        disabled={spotsLeft === 0}
        style={{
          marginTop: "10px",
          width: "100%",
          background: "#d32f2f",
          color: "#fff",
          fontWeight: "700",
          borderRadius: "8px",
          textTransform: "uppercase"
        }}
      >
        {spotsLeft === 0 ? "FULL" : "Join Contest"}
      </Button>

      {/* Almost Full Badge */}
      {isAlmostFull && spotsLeft > 0 && (
        <div
          style={{
            position: "absolute",
            top: "0",
            right: "0",
            background: "#d32f2f",
            color: "#fff",
            padding: "4px 10px",
            borderBottomLeftRadius: "12px",
            fontSize: "10px",
            fontWeight: "bold"
          }}
        >
          Almost Full
        </div>
      )}

      {children}

    </div>
  );
}
